<script>
    export let route;
    export let text;
</script>

<a href="./#/{route}">{text}</a>